import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";

import {
  Box,
  SimpleGrid,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Button,
  Heading,
} from "@chakra-ui/react";
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";
import { addCustomerLedger,updateCustomerLedger } from "../../../redux/api/customerLedger/CustomerLedgerApi";
import { addCustomerLedgerAction,updateCustomerLedgerAction } from "../../../redux/reduxSlice/customerLedgerSlice";
import { useDispatch,useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getSites } from "../../../redux/reduxApi/SiteReduxApi";
import { customStyle } from "../../../utils/commonFunction/CommonFunction";


const CustomerLedgerForm = (props) => {

   const {
    isUpdateMode,
    dataToEdit,
    formData: initialFormData,
    setIsUpdateMode,
    employeeROWID,
    onNewEmployeeAdded,
  } = props;
  
    const dispatch = useDispatch();
    const [showProgressBar, setShowProgressBar] = useState(false);
    const [submitDisabled, setSubmitDisabled] = useState(false);
    
  
  const [formData, setFormData] = useState({
    siteId:null,
    customerName: null,
    siteInKw: "",
    projectAmount: "",
    paymentPending: "",
    paymentReceived: "",
    paymentType: "",
    dueDate: "",
    duePayment: "",
    workStatus: "",
    remark: "",
    finalizeBy: "",
    lastFollowUp: "",
    audios: "",
    videos: "",
    totalReminder: "",
    totalVisitForPayment: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };


  const { closeDrawer } = props;

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowProgressBar(true);
    addCustomerLedger({...formData, createdBy: localStorage.getItem("email")})
      .then((response) => {
        console.log("Response - ", response);
        if (response.data.success) {
          const ROWID = response.data.data.ROWID;
          dispatch(addCustomerLedgerAction({ ROWID, formData }));
          console.log(response);
          setShowProgressBar(false);
          toast.success("Customer Ledger added successfully!");
          handleOnClose();
          setFormData();
          setShowProgressBar(false);
        } else {
          toast.error("Unable to add Customer Ledger , Please try again!");
        }
      })
      .catch((error) => {
        console.error("API Error", error);
        toast.error("Failed to add Customer Ledger. Please try again.");
      });
  };



    useEffect(() => {
      if (isUpdateMode && dataToEdit) {
        console.log("dataToEdit",dataToEdit)
        
        setFormData((prev) => ({
          ...prev,
          ...props.dataToEdit,
        }));
      }
    }, [isUpdateMode, dataToEdit]);

      useEffect(() => {
        const page = 1;
        // setLoading(true);
        dispatch(getSites(page)).then((response) => {
        }).catch((error) => {
          console.log(error)
        }).finally(() => {
          // setLoading(false);
          setTimeout(() => {
          }, [300])
        })
      }, [])

    const getSiteData = useSelector((state) => state.site.site)
    const [siteData, setSiteData] = useState("");
    console.log("siteData",siteData);
    
    
    console.log("Site Data", getSiteData)

      const siteLookUpdata = useMemo(() => {
        return getSiteData.map((item) => ({
          label: item?.sites?.siteName,
          value: item?.sites?.ROWID,
        }));
      }, [JSON.stringify(getSiteData)]);
      console.log("siteLookUpdata", siteLookUpdata);


        useEffect(() => {
          setSiteData(siteLookUpdata);
        }, [siteLookUpdata]);
      

console.log("formData",formData);


    const handelOnUpdate = (e) => {
      e.preventDefault();
      setShowProgressBar(true);
      updateCustomerLedger(formData.ROWID,formData)
        .then((response) => {
          console.log({ response });
          if (response.data.success) {
            setFormData((prev) => ({
              ...prev,
              ROWID: response?.data?.ROWID,
            }));
            dispatch(updateCustomerLedgerAction(formData));
            toast?.success("Customer Ledger Updated SuccesFully !!");
            setShowProgressBar(false);
  
          }
          setTimeout(() => {
            handleOnClose();
            setShowProgressBar(false);
            setSubmitDisabled(false);
          }, 300);
        })
        .catch((error) => {
          console.log(error);
          toast.error("Customer Ledger Updation Failed !");
        })
        .finally(() => {
          setSubmitDisabled(false);
        });
    };



  const handleOnClose = () => {
    closeDrawer();
     setIsUpdateMode(false);
    setFormData({
    siteId:null,
    customerName:null,
    siteInKw: "",
    projectAmount: "",
    paymentPending: "",
    paymentReceived: "",
    paymentType: "",
    dueDate: "",
    duePayment: "",
    workStatus: "",
    remark: "",
    finalizeBy: "",
    lastFollowUp: "",
    audios: "",
    videos: "",
    totalReminder: "",
    totalVisitForPayment: "",
    });
  };

    const customComponents = {
      MenuList: (props) => (
        <div style={{ position: "relative" }}>
          <div
            {...props.innerProps}
            className="custom-menu-list"
            style={{
              maxHeight: "200px",
              overflowY: "auto",
              paddingBottom: "40px",
            }}
          >
            {props.children}
          </div>
          <div
            className="add-new-option"
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              backgroundColor: "#fff",
              borderTop: "1px solid #ddd",
              padding: "3px",
              textAlign: "center",
            }}
          >
           
          </div>
        </div>
      ),
    };


    const paymentTypeOptions = [
        { value: '', label: 'None-' },
        { value: 'cash', label: 'Cash' },
        { value: 'loan', label: 'Loan' },
        { value: 'loan and cash', label: 'loan and cash' },
    ]

        const workStatusOptions = [
        { value: '', label: 'None-' },
        { value: 'pending', label: 'Pending' },
        { value: 'In-Progress', label: 'In Progress' },
        { value: 'completed', label: 'Completed' },
    ]
  


  return (
    <>
      <Drawer
        isOpen={props.isDrawerOpen}
        placement="right"
        size="xl"
        onClose={handleOnClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>  {isUpdateMode ? "Update Customer Ledger" : "Create Customer Ledger"}</DrawerHeader>
          <DrawerBody>
            <Box
              maxW="1000px"
              mx="auto"
              p={6}
              bg="white"
              
              borderRadius="md"
            >
              

              <form onSubmit={isUpdateMode ? handelOnUpdate : handleSubmit}>
                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={5}>
                  <FormControl>
                    <FormLabel>Site ID</FormLabel>
                    <Select
                      name="siteId"
                      options={siteLookUpdata}
                      defaultValue={siteLookUpdata.find((item) => item.value === formData?.siteId)}
                      onChange={(option) => {
                        setFormData((prevFormData) => ({ ...prevFormData, siteId: option.value }));
                      }}
                      styles={{
                        ...customStyle,
                        menu: (provided) => ({
                          ...provided,
                          maxHeight: 200, 
                          overflowY: "auto", 
                        }),
                      }}
                      components={customComponents}
                    />
                                        
                  
                  </FormControl>

                  <FormControl>
                    <FormLabel>Customer Name</FormLabel>
                    <Input
                    type="text"
                      name="customerName"
                      placeholder="Customer Name"
                      value={formData?.customerName}
                      onChange={handleChange}
                    />
                  </FormControl>

                  <FormControl>
                    <FormLabel>Site in KW</FormLabel>
                    <Input
                    type="number"
                      name="siteInKw"
                        placeholder="Site In Kw"
                      value={formData?.siteInKw}
                      onChange={handleChange}
                    />
                  </FormControl>

                  <FormControl>
                    <FormLabel>Project Amount</FormLabel>
                    <Input
                    type="number"
                      name="projectAmount"
                        placeholder="Project Amount"
                      value={formData?.projectAmount}
                      onChange={handleChange}
                    />
                  </FormControl>

                  <FormControl>
                    <FormLabel>Payment Pending</FormLabel>
                    <Input
                    type="number"
                      name="paymentPending"
                        placeholder="Payment Pending"
                      value={formData?.paymentPending}
                      onChange={handleChange}
                    />
                  </FormControl>

                  <FormControl>
                    <FormLabel>Payment Received</FormLabel>
                    <Input
                    type="number"
                      name="paymentReceived"
                        placeholder="Payment Received"
                      value={formData?.paymentReceived}
                      onChange={handleChange}
                    />
                  </FormControl>

                  <FormControl>
                    <FormLabel>Payment Type</FormLabel>
                    <Select
                      name="paymentType"
                      options={paymentTypeOptions}
                      value={paymentTypeOptions.find((item) => item.value === formData?.paymentType) || null}
                      onChange={(option) => {
                        setFormData((prevFormData) => ({
                          ...prevFormData,
                          paymentType: option.value,
                        }));
                      }}
                      styles={customStyle}
                      placeholder="None-"
                    />
                  </FormControl>

                  <FormControl>
                    <FormLabel>Due Date</FormLabel>
                    <Input
                      type="date"
                      name="dueDate"
                        placeholder="Due Date"
                      value={formData?.dueDate}
                      onChange={handleChange}
                    />
                  </FormControl>

                  <FormControl>
                    <FormLabel>Due Payment</FormLabel>
                    <Input
                    type="number"
                      name="duePayment"
                        placeholder="Due Payment"
                      value={formData?.duePayment}
                      onChange={handleChange}
                    />
                  </FormControl>

                  <FormControl>
                    <FormLabel>Work Status</FormLabel>
                    {/* <Select
                      name="workStatus"
                        placeholder="Work Status"
                      value={formData.workStatus}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="pending">Pending</option>
                      <option value="inProgress">In Progress</option>
                      <option value="completed">Completed</option>
                    </Select> */}
                    <Select
                      name="workStatus"
                      options={workStatusOptions}
                      value={workStatusOptions.find((item) => item.value === formData?.workStatus) || null}
                      onChange={(option) => {
                        setFormData((prevFormData) => ({
                          ...prevFormData,
                          workStatus: option.value,
                        }));
                      }}
                      styles={customStyle}
                      placeholder="None-"
                    />
                  </FormControl>

                  <FormControl>
                    <FormLabel>Remark</FormLabel>
                    <Textarea
                      name="remark"
                      placeholder="Remark"
                      value={formData?.remark}
                      onChange={handleChange}
                    />
                  </FormControl>

                  <FormControl>
                    <FormLabel>Finalized By</FormLabel>
                    <Input
                      name="finalizedBy"
                        placeholder="Finalized By"
                      value={formData?.finalizeBy}
                      onChange={handleChange}
                    />
                  </FormControl>

                  <FormControl>
                    <FormLabel>Last Follow Up</FormLabel>
                    <Input
                      type="date"
                      name="lastFollowUp"

                      value={formData?.lastFollowUp}
                      onChange={handleChange}
                    />
                  </FormControl>

                  <FormControl>
                    <FormLabel>Audio/Video Upload</FormLabel>
                    <Input
                      type="file"
                      name="audioVideoUpload"
                      onChange={handleChange}
                    />
                  </FormControl>

                  <FormControl>
                    <FormLabel>Total Reminder</FormLabel>
                    <Input
                     type="number"
                      name="totalReminder"
                        placeholder="Total Reminder"
                      value={formData?.totalReminder}
                      onChange={handleChange}
                    />
                  </FormControl>

                  <FormControl>
                    <FormLabel>Total Visit for Payment</FormLabel>
                    <Input
                     type="number"
                      name="totalVisitForPayment"
                        placeholder="Total Visit for Payment"
                      value={formData?.totalVisitForPayment}
                      onChange={handleChange}
                    />
                  </FormControl>
                </SimpleGrid>

             
              </form>
            </Box>
          </DrawerBody>
          <center>
            <DrawerFooter style={{ display: "inline-block" }}>
              <div className="gap-3 d-flex">
                <button onClick={handleOnClose} variant="outline" mr={3} className="cancel-button">
                  Cancel
                </button>
                <button
                  className="create-button"
                  onClick={(e) => {
                    !isUpdateMode ? handleSubmit(e) : handelOnUpdate(e);
                  }}
                >
                  {isUpdateMode ? "Update" : "Submit"}
                </button>
              </div>
            </DrawerFooter>
          </center>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default CustomerLedgerForm;
